<template>
    <div :class="isLoading ? 'is-loading' : ''">

        <h2 class="h3 hr-middle-after mb-4">
            <span class="bg-white d-inline-block pe-5">{{ translate('News') }}</span>
        </h2>

        <p v-if="!news.length && !isLoading" class="text-center mb-4">
            {{ translate('No items available') }}
        </p>

        <article v-for="article in news" :key="article.id" class="link-list-item mb-3">
            <a :href="article.link" class="stretched-link"></a>
            <div class="d-flex">
                <div class="min-w-0 flex-grow-1 px-4 py-4">
                    <p class="text-secondary fw-semibold">
                        <small class="text-nowrap">
                            {{ article.date }}
                        </small>
                    </p>
                    <h3 class="text-truncate h6 my-2">
                        {{ article.heading }}
                    </h3>
                    <p class="text-truncate-lines-2">
                        {{ article.perex }}
                    </p>
                </div>
                <div class="flex-shrink-0 d-none d-md-flex align-items-center">
                    <div class="post-arrow">
                        <svg class="icon-post-arrow">
                            <use xlink:href="#icon-chevron-right"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </article>

        <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between mt-4 d-print-none">
            <a :href="showMoreLink" class="link-primary fw-semibold fs-6">
                <svg class="icon-archive me-1">
                    <use xlink:href="#icon-archive"></use>
                </svg>
                <u>
                    {{ translate('News Archive') }}
                </u>
            </a>
            <button class="btn btn-primary text-uppercase mt-4 mt-sm-0" v-show="news.length < totalCount" @click.prevent="loadNews(true)">{{ translate('More News') }}</button>
        </div>

    </div>
</template>

<script>
import { translate } from '@/scripts/mixins/translations';

export default {
    props: {
        showMoreLink: String
    },
    mixins: [
        translate
    ],
    data(){
        return {
            isLoading: false,
            filters: {
                count: 6,
                offset: 0
            },
            totalCount: 0,
            news: []
        }
    },
    methods: {
        loadNews(incrementFilters = false){
            this.isLoading = true;

            if ( incrementFilters )
            {
                this.filters.offset += this.filters.count;
            }

            axios.get(`news/list?offset=${this.filters.offset}&count=${this.filters.count}`)
            .then(response => {
                const { data } = response;
                this.news.push(...data.news);
                this.totalCount = data.total_count;
            })
            .finally(() => {
                this.isLoading = false;
            });
        }
    },
    mounted(){
        this.loadNews(false);
    }
}
</script>